// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"D_tw h_jp h_fp h_fs h_fD h_dL h_t","menuItemSub":"D_tx h_dS h_fp h_fD","menuMainLink":"D_ty h_jq h_hk","menuLink":"D_tz h_jq h_hk","Link":"D_r9 v_r9 v_rv v_rQ"};